import { Injectable } from '@angular/core';

// Model
import { ResultAbonado, ResultAutenticar, IGenericResult } from '../../models/abonado.model';
import { ResultAbonadoLicencia } from '../../models/abonado.model';
import { environment } from '../../../environments/environment';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HTTPOPTIONS } from '../../common/constants';
import { ResultBeneficiario } from '../../models/beneficiario.model';
import { ResultZona } from '../../models/zonas.model';
import { Respuesta } from 'src/app/models/respuesta';

// sweetalert2
import swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AbonadoService {

  private abonadoUrl = environment.apiBaseUrl + '/abonado';
  private beneficiarioUrl = environment.apiBaseUrl + '/beneficiario';
  private zonaUrl = environment.apiBaseUrl + '/zona';

  constructor(private http: HttpClient) { }

  public getAbonadoLicencia() {
    return this.http.post<ResultAbonadoLicencia>(this.abonadoUrl + '/list', null, HTTPOPTIONS)
      .pipe(
        map((resp) => {
          return resp.abonado;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public getBeneficiarios(idabonado: number) {
    return this.http.post<ResultBeneficiario>(this.beneficiarioUrl + '/list', { 'idabonado': idabonado }, HTTPOPTIONS)
      .pipe(
        map((resp: ResultBeneficiario) => {
          return resp;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public getZonas(idabonado: number) {
    return this.http.post<ResultZona>(this.zonaUrl + '/list', { 'idabonado': idabonado }, HTTPOPTIONS)
      .pipe(
        map((resp: ResultZona) => {
          return resp;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public agregarEquipo(datos: any): Observable<Respuesta> {
    return this.http.post<Respuesta>(this.abonadoUrl + '/agregar', datos, HTTPOPTIONS)
      .pipe(
        map((res: Respuesta) => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public contactos(idabonado: Number) {
    return this.http.post(this.abonadoUrl + '/contactos', { idabonado }, HTTPOPTIONS)
      .pipe(
        map((resp: any) => {
          return resp.contactos;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public getAbonadoForMac(macabonado: string): Observable<ResultAbonado> {
    return this.http.post<ResultAbonado>(this.abonadoUrl + '/obtener', { macabonado }, HTTPOPTIONS)
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public autenticarAbonado(idabonado: number, macabonado: string, usuario: string, password: string): Observable<ResultAutenticar> {
    return this.http.post<ResultAutenticar>(`${this.abonadoUrl}/autenticar`, { idabonado, macabonado, usuario, password }, HTTPOPTIONS)
      .pipe(
        map((resp) => { return resp; }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public coaccion(idabonado: Number) {
    return this.http.post(this.abonadoUrl + '/coaccion', { idabonado }, HTTPOPTIONS)
      .pipe(
        map((resp: any) => {
          return resp.coaccion;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public monitoreoAbonados(idmonitoreo: Number) {
    return this.http.post(this.abonadoUrl + '/monitoreo', { idmonitoreo }, HTTPOPTIONS)
      .pipe(
        map((resp: any) => {
          return resp.abonados;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public getAbonadoxMac(mac: string) {
    return this.http.post(this.abonadoUrl + '/abonadomac', { mac }, HTTPOPTIONS)
      .pipe(
        map((resp: any) => {
          return resp.abonado;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public getAbonadoxCliente(idcliente: number) {
    return this.http.post(this.abonadoUrl + '/abonadocliente', { idcliente }, HTTPOPTIONS)
      .pipe(
        map((resp: any) => {
          return resp.abonado;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public actualizarImgAbonado(foto: any): Observable<Respuesta> {
    return this.http.put<Respuesta>(this.abonadoUrl + '/actualizarfoto', foto, HTTPOPTIONS)
      .pipe(
        map((res: Respuesta) => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public getBeneficiariosxAbonado(idabonado: Number) {
    return this.http.post(this.abonadoUrl + '/beneficiarios', { idabonado }, HTTPOPTIONS)
      .pipe(
        map((resp: any) => {
          return resp.beneficiarios;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public getZonasxAbonado(idabonado: Number) {
    return this.http.post(this.abonadoUrl + '/zonas', { idabonado }, HTTPOPTIONS)
      .pipe(
        map((resp: any) => {
          return resp.zonas;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public updateCoaccion(coaccion: any): Observable<Respuesta> {
    return this.http.put<Respuesta>(this.abonadoUrl + '/updatecoaccion', coaccion, HTTPOPTIONS)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public updateUbicacion(ubicacion: any): Observable<Respuesta> {
    return this.http.put<Respuesta>(this.abonadoUrl + '/updateubicacion', ubicacion, HTTPOPTIONS)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public registrarEquipo(datos: any): Observable<Respuesta> {
    return this.http.post<Respuesta>(`${this.abonadoUrl}/registrar`, datos, HTTPOPTIONS)
      .pipe(
        map((res: Respuesta) => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public getListadoAbonado() {
    return this.http.post(this.abonadoUrl + '/listadoabonado', HTTPOPTIONS)
      .pipe(
        map((resp: any) => {
          return resp.abonado;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public registrarContacto(contacto: any): Observable<Respuesta> {
    return this.http.post<Respuesta>(this.abonadoUrl + '/registrar/contactos', contacto, HTTPOPTIONS)
      .pipe(
        map((res: Respuesta) => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public updateContacto(contacto: any): Observable<Respuesta> {
    return this.http.post<Respuesta>(this.abonadoUrl + '/update/contactos', contacto, HTTPOPTIONS)
      .pipe(
        map((res: Respuesta) => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public eliminarContacto(idpersonacontacto: number): Observable<Respuesta> {
    return this.http.post<Respuesta>(this.abonadoUrl + '/eliminar/contactos', { idpersonacontacto }, HTTPOPTIONS)
      .pipe(
        map((res: Respuesta) => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
      );
  }

  public eliminarAbonadoMonitoreo(data: any): Promise<any> {
    return this.http.post<any>(this.abonadoUrl + '/eliminar/monitoreo', data, HTTPOPTIONS)
      .pipe(
        map((res: any) => {
          return res;
        })
      ).toPromise();
  }

  public editAbonado(data: any): Observable<IGenericResult> {
    return this.http.post<any>(this.abonadoUrl + '/editar', data, HTTPOPTIONS)
      .pipe(
        map((resp: IGenericResult) => resp),
        catchError((err: HttpErrorResponse) => Observable.throw(err))
      );
  }

}
